module.exports = "/packs/writing_exam_complete_ribbon-58d53dab5b3ec148ba91971ddd692b0a.svg";